<div [ngClass]="{ hidden: !subscriptionStatusBarVisible() }" class="d-inline-block ml-3 glowing">
    @if (appSession.tenant.isInTrialPeriod && !subscriptionIsExpiringSoon()) {
        <span [innerHTML]="getTrialSubscriptionNotification()"></span>
    }
    @if (subscriptionIsExpiringSoon()) {
        <a routerLink="/app/admin/subscription-management">
            @if (subscriptionIsExpiringSoon() && appSession.tenant.isInTrialPeriod) {
                <span>
                    <i class="fa fa-exclamation-circle"></i>
                    {{ getExpireNotification('TrialExpireNotification') }}
                </span>
            }
            @if (subscriptionIsExpiringSoon() && !appSession.tenant.isInTrialPeriod) {
                <span>
                    <i class="fa fa-exclamation-circle"></i>
                    {{ getExpireNotification('SubscriptionExpireNotification') }}
                </span>
            }
        </a>
    }
</div>
